import type { ProfileComponentConfig } from './ProfileComponent';

/** Normalize component config before persisting (strip empty placeholder fields). */
export function sanitizeProfileComponentConfig(
  config: ProfileComponentConfig,
): ProfileComponentConfig {
  const next: ProfileComponentConfig = { ...config };

  // Firestore rejects undefined field values, so keys must be absent, not undefined.
  for (const key of Object.keys(next) as Array<keyof ProfileComponentConfig>) {
    if (next[key] === undefined) {
      delete next[key];
    }
  }

  if (next.embedId === '' || next.embedId === 'x') {
    delete next.embedId;
  }
  if (next.imageUrl === '') {
    delete next.imageUrl;
  }
  if (next.url === '' || next.url === '#') {
    delete next.url;
  }
  if (next.handle === '') {
    delete next.handle;
  }
  if (next.note === '') {
    delete next.note;
  }
  if (next.caption === '') {
    delete next.caption;
  }
  if (next.content === '') {
    delete next.content;
  }

  return next;
}
